import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SearchResponse } from '@algolia/client-search';
import { WritableDraft } from 'immer';

export interface PortsGalleryParams {
  filters: string;
  facets: string;
}

export interface PortsGalleryState {
  itineraryDetailsData: SearchResponse | null;
  params: PortsGalleryParams | null;
  loading: boolean;
  error: string | null;
}

const initialState: PortsGalleryState = {
  itineraryDetailsData: null,
  params: null,
  loading: false,
  error: null,
};

const portsGallerySlice = createSlice({
  name: 'portsGallery',
  initialState,
  reducers: {
    portsGalleryRequest: (state, action: PayloadAction<PortsGalleryParams>) => {
      state.params = action.payload;
      state.loading = true;
      state.error = null;
    },
    portsGallerySuccess: (state, action: PayloadAction<SearchResponse>) => {
      state.loading = false;
      state.itineraryDetailsData = action.payload as WritableDraft<SearchResponse>;
      state.error = null;
    },
    portsGalleryFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const { portsGalleryRequest, portsGallerySuccess, portsGalleryFailure } =
  portsGallerySlice.actions;

export default portsGallerySlice.reducer;
